var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(_vm.user)?_c('div',{staticClass:"col-4"},[_c('User',{attrs:{"user":_vm.user}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }